import React, { useContext } from 'react';
import acceptedCards from '../../../images/accepted_cards.svg';
import { ConfigContext } from '../../../context/Config';
import Button from '../../Button';
import '../Checkout.less';

export type ArcaProps = {
  onSelect?: (type: string) => void;
};

const TArca: React.FC<ArcaProps> = ({ onSelect }) => {
  const { translate } = useContext(ConfigContext);
  return (
    <div className="t-payment t-payment-arca">
      <img
        src={acceptedCards}
        alt="accepted_cards"
        onClick={() => onSelect('arca')}
      />
    </div>
    // <Button
    //   fullWidth
    //   htmlType="button"
    //   className="t-payment t-payment-arca"

    // >
    //   {translate('Click to redirect payment page')}
    // </Button>
  );
};

export default TArca;
